module.exports = __webpack_public_path__ + "img/dsj_jb.f22798d0.png";